var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRightThick = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.72 11.73a2.37 2.37 0 00-.14-.57 1.42 1.42 0 00-.08-.16 2.1 2.1 0 00-.37-.56l-6-6.86a2.38 2.38 0 00-3.35-.22 2.38 2.38 0 00-.22 3.35l2.56 2.94H4.43A2.4 2.4 0 002 11.89a2.39 2.39 0 002.37 2.49h9.77l-2.56 2.93a2.38 2.38 0 00.22 3.35 2.37 2.37 0 003.35-.22l6-6.85a2.18 2.18 0 00.35-.59 1.08 1.08 0 00.08-.19 2.22 2.22 0 00.14-.55 2.62 2.62 0 000-.28 2.44 2.44 0 000-.25z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRightThick);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-right-thick.5132ad5bbdd51a6b775a1879b15df11a.svg";